import { inject, observer } from 'mobx-react';
import * as React from 'react';
import {
	ErrorMessagesViewModelKey,
	IErrorMessageComponentProps,
	IUserSessionComponentProps,
	UserSessionViewModelKey,
} from '../../../../models/AppState';
import { MultiContainerHeader } from '../../../../web/components/MultiContainerHeader';
import { useHangfireAuthTokenMutation } from '../../../hooks/useHangfireAuthToken';
import { IHangfireOperationsAuthTokenResult } from '../../../models';
import { tableStyles } from './styles';

type IProps = IErrorMessageComponentProps & IUserSessionComponentProps;

type IGroupedData = Record<string, IHangfireOperationsAuthTokenResult[]>;

function groupDataByScheduler(data: IHangfireOperationsAuthTokenResult[]): IGroupedData {
	const groupedData: IGroupedData = {};
	data.forEach(item => {
		if (!groupedData[item.scheduler]) {
			groupedData[item.scheduler] = [];
		}
		groupedData[item.scheduler].push(item);
	});
	return groupedData;
}

function _Hangfire({ userSession, errorMessages }: IProps) {
	const mutation = useHangfireAuthTokenMutation({
		handleError: err => {
			errorMessages.pushApiError(err);
		},

		userSession,
	});
	React.useEffect(() => {
		mutation.mutate();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (!mutation.data) {
		return <div>Loading...</div>;
	}

	const groupedData: IGroupedData = groupDataByScheduler(mutation.data);

	return (
		<>
			<MultiContainerHeader fullscreenHeader='Hangfire Dashboards' />
			<div style={{ maxWidth: 500 }}>
				<table style={tableStyles.table}>
					<thead>
						<tr>
							<th style={tableStyles.th}>Scheduler</th>
							<th style={tableStyles.th}>Dashboards</th>
						</tr>
					</thead>
					<tbody>
						{Object.entries(groupedData).map(([scheduler, items]) => (
							<tr key={scheduler}>
								<td style={tableStyles.td}>{scheduler}</td>
								<td style={tableStyles.td}>
									{items.map((item, index) => (
										<div key={index}>
											<a href={item.dashboardUrl} target='_blank' rel='noopener noreferrer' style={tableStyles.link}>
												{item.dashboard}
											</a>
										</div>
									))}
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</>
	);
}

export const Hangfire = inject(UserSessionViewModelKey, ErrorMessagesViewModelKey)(observer(_Hangfire));
